// extracted by mini-css-extract-plugin
export var header = "_vb-1";
export var maskBottom = "_vb-6";
export var maskMiddle = "_vb-7";
export var maskTop = "_vb-5";
export var root = "_vb-0";
export var scrollDownButton = "_vb-3";
export var scrollDownButtonHidden = "_vb-4";
export var viewport = "_vb-2";